import { Stack, Typography } from '@mui/material'

import { preview } from '@/components/form/preview'

import { useTexts } from '../useTexts'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function TimeWindowExceptions(props: Props) {
  const { extOrder } = props

  const texts = useTexts()

  const shouldRender = Object.keys(extOrder.orderStep.timeWindowExceptions).length > 0

  if (!shouldRender) {
    return (
      <preview.Field label={texts.timeWindowsExceptions.label}>
        <preview.NullValue />
      </preview.Field>
    )
  }

  return (
    <Stack spacing={1}>
      <preview.Label>{texts.timeWindowsExceptions.label}</preview.Label>
      {Object.entries(extOrder.orderStep.timeWindowExceptions).map(([date, tws], index) => (
        <preview.Value key={`${date}_${index}`}>
          <Stack spacing={1}>
            <Stack spacing={1}>
              <preview.DateValue>{date}</preview.DateValue>
            </Stack>
            <Stack spacing={1} sx={{ paddingLeft: 2, backgroundColor: '#F9FAFB' }}>
              {tws.map((tw, twIndex) => (
                <Typography key={`${tw.startSec}-${tw.endSec}-${twIndex}`} variant="body1">
                  <preview.TimeWindow tw={tw} />
                </Typography>
              ))}
            </Stack>
          </Stack>
        </preview.Value>
      ))}
    </Stack>
  )
}
